import React, { useContext, useEffect, useState } from 'react'
import logo from '../Assest/logo.png'
import invisible from '../Assest/invisibleKey.png'
import visible from '../Assest/visibleKey.png'
import { NavLink } from 'react-router-dom'
import { urlApiServer } from '../Config/Config'
import Swal from 'sweetalert2'
import LoginContext from '../Context/Logincontext';
import '../styles/Register.css'
import Nav1 from '../Component/Nav/Nav1'
import { ImExit } from 'react-icons/im'
import CloseButton from '../Component/CloseButton'
import { useNavigate } from 'react-router-dom'
import LogoComponent from '../Component/LogoComponent'

let splitImg = []


const CompanyInfo = () => {

    const urlUpdateUserCompany = urlApiServer + "updateCompany";
    const urlgetUserCompany = urlApiServer + "getUserCompany";

    const [name, setName] = useState()
    const [nit, setNit] = useState()
    const [type, setType] = useState(null)
    const [phone, setPhone] = useState(null)
    const [numberAccount, setNumberAccount] = useState()
    const [bank, setBank] = useState()
    const [address, setAddress] = useState()

    // const [phone, setPhone] = useState()
    const [email, setEmail] = useState()
    const [users, setUsers] = useState([])
    const [emailValidation, setEmailValidation] = useState("");
    const [password, setPassword] = useState()
    const [checkPassword, setCheckpassword] = useState()
    const { infoUser, setInfoUser } = useContext(LoginContext)
    const [oldConfig, setOldConfig] = useState("")
    const [logo, setLogo] = useState("")
    const [closeSession, setCloseSession] = useState(false)
    const navigate = useNavigate();

    const urlGetClient = urlApiServer + "users"

    useEffect(() => {
        (async function () {

            const InicioHeaders = new Headers();
            InicioHeaders.append("Content-Type", "application/json")
            const data = JSON.stringify({
                nameUser: infoUser.name,
                nameCompany: infoUser.company,
            })
            const requesoption = {
                method: 'POST',
                headers: InicioHeaders,
                body: data,
                redirect: 'follow'
            }
            await fetch(urlgetUserCompany, requesoption).then(response => response.json()).then(quotesResponse => {
                // setOldConfig(quotesResponse)
                console.log("quotesResponse = ", quotesResponse.data.company[0])
                setName(quotesResponse.data.company[0].nameCompany.split("_")[1])
                setNit(quotesResponse.data.company[0].companyNit)
                setPhone(quotesResponse.data.company[0].companyPhone)
                setType(quotesResponse.data.company[0].companyAccountBankType)
                setNumberAccount(quotesResponse.data.company[0].companyAccountBank)
                setBank(quotesResponse.data.company[0].companyBank)
                setAddress(quotesResponse.data.company[0].companyAddress)
            })
        }())


    }, [])

    useEffect(() => {
        if (oldConfig) {
            const foundConfig = oldConfig.find(obj => obj.empresa === infoUser.company);
            if (foundConfig) {
                const { logo } = foundConfig;
                setLogo(logo);

            }
        }
    }, [oldConfig, infoUser])

    if (logo) {
        splitImg = logo.split("|")
    }

    useEffect(() => {
        (async function () {

            const InicioHeaders = new Headers();
            InicioHeaders.append("Content-Type", "application/json")

            const requesoption = {
                method: 'GET',
                headers: InicioHeaders,
                redirect: 'follow'
            }
            await fetch(urlGetClient, requesoption).then(response => response.json()).then(usersResponse => {
                setUsers(usersResponse)
            })
        }())
    }, [email])

    useEffect(() => {
        if (closeSession) {
            setInfoUser({
                login: false,
                name: "unknow",
                email: "unknow",
                role: "unknow",
                company: "unknow",
                colorNeonAndButtons: "Red",
                backgroundColorIcons: "Red",
                colorIcons: "white",
                tittleColor: "white",
                letterColor: "white",
                mainColor: [82, 81, 81, 0.691],
                secondaryColor: [82, 81, 81, 0.3],
                logo: "defaultLogo.png",
                backgroundImg: "default.jpeg",
            })
        }
    }, [closeSession])

    async function close() {
        window.location.href = './Login';
        setCloseSession(true)
    }

    async function handleName(e) {

        const name = e.target.value
        if (name.length > 30) {
            Swal.fire({
                icon: 'warning',
                text: 'Nombre muy largo'
            })
        } else {
            await setName(name)
        }
    }
    async function handleNiT(e) {
        const surNames = e.target.value
        // if(surNames.length > 30){
        //     Swal.fire({
        //         icon: 'warning',
        //         text: 'Amuy largo'
        //     })
        // }else{
        await setNit(surNames)
        // }
    }
    async function handleType(e) {
        const type = e.target.value
        // if(type === null){
        //     Swal.fire({
        //         icon: 'warning',
        //         text: 'Seleccione un tipo de documento'
        //     })
        // }else{
        await setType(type)
        // }
    }
    async function handlePhone(e) {
        const phone = e.target.value
        // if(rol === null){
        //     Swal.fire({
        //         icon: 'warning',
        //         text: 'Seleccione un tipo de documento'
        //     })
        // }else{
        await setPhone(phone)
        // }
    }
    async function handleNumberAccount(e) {
        const numberDocument = e.target.value
        // if(surNames.length > 30){
        //     Swal.fire({
        //         icon: 'warning',
        //         text: 'Documento muy larga'
        //     })
        // }else{
        await setNumberAccount(numberDocument)
        // }
    }


    async function handleBank(e) {
        const bank = e.target.value
        // if(surNames.length > 30){
        //     Swal.fire({
        //         icon: 'warning',
        //         text: 'Documento muy larga'
        //     })
        // }else{
        await setBank(bank)
        // }
    }

    async function handleAddress(e) {
        const address = e.target.value
        // if(surNames.length > 30){
        //     Swal.fire({
        //         icon: 'warning',
        //         text: 'Documento muy larga'
        //     })
        // }else{
        await setAddress(address)
        // }
    }

    async function updateCompanyInfo() {
        // if (emailValidation === "correo valido") {
        console.log("numberAccount: ",numberAccount)
            const data = JSON.stringify({
                nameCompany: infoUser.company,
                // name: name,
                companyBank: bank,
                companyAccountBankType: type,
                companyAccountBank: numberAccount,
                companyPhone: phone,
                companyNit: nit,
                companyAddres: address,
                // rol: rol
            })
            const registerHeaders = new Headers();
            registerHeaders.append("Content-Type", "application/json")

            const requesoption = {
                method: 'PUT',
                headers: registerHeaders,
                body: data,
                redirect: 'follow'
            }

            fetch(urlUpdateUserCompany, requesoption).then(response => response.json())
                .then(dataResponse => {
                    console.log("dataResponse: ", dataResponse)
                    if (200 === dataResponse.status) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Actualizacion Correcta',
                            text: 'Has actualizado sus datos correctamente',
                            allowOutsideClick: false, // Evita hacer clic fuera del cuadro de diálogo
                        }).then((result) => {
                            window.location.href = './Informacion_Empresa'
                        })
                    } else if (1062 === dataResponse.msj.errno) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Este email ya existe',
                        })
                    } else if (983 === dataResponse.status) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Tienes un campo vacio',
                        })
                    }
                })
        // } else {
        //     Swal.fire({
        //         icon: 'error',
        //         title: 'Error!',
        //         text: 'Tu correo esta en un formato invalido',
        //     })
        // }
    }

    return (
        <>
            {(infoUser.role === 'SuperUsuario') ? (
                window.location.href = './Crear_Empresa'
            ) : (
                <>
                    <div className="containerHeardANDTable">
                        <div className="HeardANDFilter">
                            <LogoComponent />
                            <div className='containerButtonAdd'>
                                <div className="navigationContainer">
                                    <div className="pageTitle">INFORMACION DE EMPRESA</div>
                                </div>
                            </div>
                            <div className='closeIntContainer'>
                                <CloseButton />
                            </div>
                        </div>
                    </div>
                    <div id='overallContainer' className='overallContainer'>
                        <Nav1 />
                        {(infoUser.login === true) ? (
                            <div className='registerContainer'>
                                <div className='drawerFormRegister' autocomplete="off">
                                    <form className='ContainerProfile'>
                                        <div className="inputUsersContainer">
                                            <input
                                                type="text"
                                                name="name"
                                                id="name"
                                                onChange={handleName}
                                                className="inputUsers"
                                                placeholder=" "
                                                value={name}
                                                disabled
                                            />
                                            <label htmlFor="name">Nombre de la Empresa</label>
                                        </div>
                                        <div className="inputUsersContainer">
                                            <input
                                                type="text"
                                                name="surNames"
                                                id="surNames"
                                                onChange={handleNiT}
                                                className="inputUsers"
                                                // placeholder=
                                                value={nit}
                                            />
                                            <label htmlFor="name">Nit</label>
                                        </div>
                                        <div className="inputUsersContainer">
                                            <input
                                                type="text"
                                                name="rolSelect"
                                                id="rolSelect"
                                                onChange={handlePhone}
                                                className="inputUsers"
                                                placeholder=""
                                                list="drawfemails"
                                                value={phone}
                                            />
                                            <label htmlFor="name">Telefono</label>
                                            <datalist id="drawfemails" value="rolSelect">
                                                <option value="Administrador" />
                                                <option value="Vendedor" />
                                            </datalist>
                                        </div>
                                        <div className="inputUsersContainer">
                                            <input
                                                type="text"
                                                name="nitSelect"
                                                id="nitSelect"
                                                onChange={handleType}
                                                className="inputUsers"
                                                placeholder=""
                                                list="drawfemails2"
                                                value={type}
                                            />
                                            <label htmlFor="name">Tipo de cuenta:</label>
                                            <datalist id="drawfemails2" value={type}>
                                                <option value="Cuenta de Ahorros">Cuenta de Ahorros</option>
                                                <option value="Cuenta Corriente">Cuenta Corriente</option>
                                                <option value="Cuenta de nomina">Cuenta de nomina</option>
                                            </datalist>
                                        </div>
                                        <div className="inputUsersContainer">
                                            <input
                                                type="text"
                                                onWheel={(e) => e.target.blur()}
                                                name="citizenshipCard"
                                                id="citizenshipCard"
                                                onChange={handleNumberAccount}
                                                className="inputUsers"
                                                placeholder=" "
                                                value={numberAccount}
                                            />
                                            <label htmlFor="name">Numero de cuenta</label>
                                        </div>
                                        <div className="inputUsersContainer">
                                            <input
                                                type="text"
                                                onWheel={(e) => e.target.blur()}
                                                name="citizenshipCard"
                                                id="citizenshipCard"
                                                onChange={handleBank}
                                                className="inputUsers"
                                                placeholder=" "
                                                value={bank}
                                            />
                                            <label htmlFor="name">Banco</label>
                                        </div>
                                        <div className="inputUsersContainer">
                                            <input
                                                type="text"
                                                onWheel={(e) => e.target.blur()}
                                                name="citizenshipCard"
                                                id="citizenshipCard"
                                                onChange={handleAddress}
                                                className="inputUsers"
                                                placeholder=" "
                                                value={address}
                                            />
                                            <label htmlFor="name">Direccion</label>
                                        </div>
                                    </form>
                                    <div className="buttonContainer">
                                        <button onClick={updateCompanyInfo} className="button neon_Effect"><p>Actualizar</p></button>
                                    </div>
                                </div>
                            </div>
                        ) : (window.location.href = './Iniciar_Sesión')}

                    </div>
                </>
            )}
        </>
    )
}

export default CompanyInfo